import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    paper: {
        margin: '0!important',
        zIndex:555,
        maxWidth:'100%'
    },
    paperWithoutPortal: {
        margin: '0!important',
        zIndex:555,
        position:'absolute',
        left:'50%',
        top:'15px',
        backgroundColor:'transparent'

    },
    title: {
        cursor: 'move',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '6px 6px 6px 14px',
        minHeight: '40px',
        backgroundColor: 'var(--account-accent, rgb(92 109 126))',
        color: 'var(--account-accent-contrast, #fff)',
    },
    label: {
        flex: 1,
        minWidth: 0,
        fontSize: '13px',
        fontWeight: 700,
        letterSpacing: '0.02em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    closeIcon: {
        color: 'inherit',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.16)',
        },
    },
    content:{
        padding: 0,
        backgroundColor: '#000',
    }
}
